<template>
  <div class="container">
    <h1 class="logo"><img src="../assets/logo.svg" /></h1>
    <div class="content">
      <div class="panel">
        <!-- header -->
        <h2 v-if="!form_submit" class="h3" v-html="$t('form_title.normal')"></h2>
        <h2 v-else class="h3" v-html="$t('form_title.complete')"></h2>

        <div v-if="!form_submit" class="form">
          <!-- // form -->
          <vue-form-generator @validated="onValidated" ref="form" :schema="schema" :model="model" :options="formOptions"></vue-form-generator>
          <!-- // extra hint -->
          <div v-show="license_validate && account_validate && !form_submit" v-html="$t('phone_hint')" style="text-align: left; font-size: 0.80rem; color: #C71220"></div>

          <!-- // valdation button -->
          <div>
            <vue-recaptcha @verify="handleLicenseValidationClicked" :sitekey="recaptcha_site_key" style="display: inline-block;">
              <b-button v-show="!license_validate" variant="danger" :disabled="loading">{{ $t('button.title.validation') }}</b-button>
            </vue-recaptcha>
            <vue-recaptcha @verify="handleAcccountValidationClicked" :sitekey="recaptcha_site_key" style="display: inline-block;">
              <b-button v-show="license_validate && !account_validate" variant="danger" :disabled="loading">{{ $t('button.title.validation') }}</b-button>
            </vue-recaptcha>
          </div>

          <!-- // form button -->
          <div>
            <b-button v-show="license_validate && account_validate && !form_confirm" variant="danger" @click="handleConfirmClicked">{{ $t('button.title.confirm') }}</b-button>
            <b-button v-show="license_validate && account_validate && form_confirm && !form_submit" variant="secondary" @click="handleConfirmCancelClicked">{{ $t('button.title.modify') }}</b-button>
            <vue-recaptcha @verify="handleDoubleConfirmClicked" :sitekey="recaptcha_site_key" style="display: inline-block;">
              <b-button v-show="license_validate && account_validate && form_confirm && !form_submit" variant="danger">{{ $t('button.title.submit') }}</b-button>
            </vue-recaptcha>
          </div>
        </div>
        <div v-else class="complete_form">
          <a class="complete_header" :href="login_host" target="_blank">
            <h2>{{ $t('form_product_postfix.complete')}} </h2>
          </a>
          <div style="complete_content">
            <h2>{{ $t('form.login_account.label') }}</h2>
            <h2>{{ model.login_account }}</h2>
          </div>
        </div>

        <!-- // footer -->
        <a v-if="form_submit" class="panel-footer">{{ $t('footer_title.complete.0') }}</a>
      </div>
    </div>
    <b-modal id="validate-modal" size="lg" :title="$t('modal.validation.title')" centered hide-header-close no-close-on-backdrop no-close-on-esc @hide="closeValidateModal">
      <!-- // form -->
      <vue-form-generator @validated="onValidated" ref="validate_form" :schema="validateSchema" :model="validateModel" :options="validateFormOptions"></vue-form-generator>

      <div class="row">
        <div class="col-6 text-left">
          <span v-html="$t('modal.validation.hint')" style="font-weight: bold; font-size: 0.80rem; color: #C71220;"></span>
        </div>
        <div class="col-6 text-right">
          <vue-recaptcha @verify="handleOTPRequestClicked" :sitekey="recaptcha_site_key" style="display: inline-block;">
            <b-button variant="danger" :disabled="loading || otp_button.disabled">{{ otp_button.label }}</b-button>
          </vue-recaptcha>
        </div>
      </div>

      <!-- // buttons -->
      <template #modal-footer="{ ok, cancel }">
        <b-button variant="secondary" :disabled='loading' @click="handleSubmitCancelClicked">{{ $t('button.title.cancel') }}</b-button>
        <vue-recaptcha @verify="handleSubmitClicked" :sitekey="recaptcha_site_key">
          <b-button variant="danger" :disabled="loading || validateModel.otp_token === null || validateModel.otp_code === null">{{ $t('button.title.apply') }}</b-button>
        </vue-recaptcha>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import VueFormGenerator from "vue-form-generator";
  import VueRecaptcha from 'vue-recaptcha';

  export default {
    components: { VueRecaptcha },
    data() {
      return {
        recaptcha_site_key: null,
        login_host: '',
        otp_interval: {
          id: null,
          limit: 60,
          count: 60,
          timeout: 1000,
        },
        otp_button: {
          label: this.$t('button.title.otp_request'),
          disabled: false,
        },
        validateModel: {
          otp_token: null,
          otp_code: null,
        },
        validateSchema: {
          groups: [
            {
              model: 'validation_group',
              fields: [
                {
                  type: 'input',
                  inputType: 'text',
                  model: 'otp_code',
                  required: false,
                  validator: VueFormGenerator.validators.regexp,
                  pattern: '^[0-9]{6,6}$',
                },
              ]
            }
          ]
        },
        validateFormOptions: {
          validateAfterLoad: false,
          validateAfterChanged: true,
        },
        model: {
          license_id: null,
          license_product: null,
          license_plan: null,
          license_term: null,
          login_account: null,
          login_password: null,
          login_confirm_password: null,
          display_company: null,
          display_phone: null,
          display_international_phone: null,
          display_email: null,
        },
        schema: {
          groups: [
            // license
            {
              model: 'license_group',
              legend: '',
              fields: [
                {
                  type: 'input',
                  inputType: 'text',
                  model: 'license_id',
                  required: true,
                  disabled: () => { return this.form_confirm },
                  validator: VueFormGenerator.validators.regexp,
                  pattern: '^[a-f0-9]{8,8}-[a-f0-9]{8,8}-[a-f0-9]{8,8}-[a-f0-9]{8,8}$',
                  onChanged: () => {
                    // clean the model map
                    if (this.license_validate) {
                      let ignore_list = ['license_id']
                      for (const key in this.model) {
                        if (ignore_list.includes(key))
                          continue
                        this.model[key] = null
                      }
                      setTimeout(() => {
                        this.$refs.form.validate()
                      }, 100)
                    }

                    // clean the validatio
                    this.license_validate = false
                    this.account_validate = false
                    this.validating = false
                    this.schema.groups[0].legend = ''
                    this.schema.groups[1].legend = ''
                  }
                },
                {
                  type: 'input',
                  inputType: 'text',
                  model: 'license_product',
                  required: true,
                  visible: () => { return this.license_validate },
                  disabled: () => { return true },
                },
                {
                  type: 'input',
                  inputType: 'text',
                  model: 'license_plan',
                  required: true,
                  visible: () => { return this.license_validate },
                  disabled: () => { return true },
                },
                {
                  type: 'input',
                  inputType: 'text',
                  model: 'license_term',
                  required: true,
                  visible: () => { return this.license_validate },
                  disabled: () => { return true },
                },
              ]
            },
            // login
            {
              model: 'login_group',
              legend: '',
              fields: [
                {
                  type: 'input',
                  inputType: 'text',
                  model: 'display_company',
                  required: true,
                  min: 1,
                  max: 30,
                  visible: () => { return this.license_validate },
                  disabled: () => { return this.form_confirm },
                  validator: VueFormGenerator.validators.string
                },
                {
                  type: 'input',
                  inputType: 'text',
                  model: 'login_account',
                  required: true,
                  visible: () => { return this.license_validate },
                  disabled: () => { return this.form_confirm },
                  validator: VueFormGenerator.validators.regexp,
                  pattern: '^[a-zA-Z0-9_]{6,25}$',
                  onChanged: () => {
                    // clean the model map
                    if (this.account_validate) {
                      let ignore_list = ['license_id', 'license_product', 'license_plan', 'license_term', 'login_account', 'display_company']
                      for (const key in this.model) {
                        if (ignore_list.includes(key))
                          continue
                        this.model[key] = null
                      }
                      setTimeout(() => {
                        this.$refs.form.validate()
                      }, 100)
                    }

                    // clean the validatio
                    this.account_validate = false
                    this.validating = false
                  }
                },
                {
                  type: 'input',
                  inputType: 'password',
                  model: 'login_password',
                  required: true,
                  visible: () => { return this.license_validate && this.account_validate },
                  disabled: () => { return this.form_confirm },
                  validator: VueFormGenerator.validators.regexp,
                  pattern: '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[~!@#$^*_+])[A-Za-z0-9~!@#$^*_+]{8,20}$'
                },
                {
                  type: 'input',
                  inputType: 'password',
                  model: 'login_confirm_password',
                  required: true,
                  visible: () => { return this.license_validate && this.account_validate },
                  disabled: () => { return this.form_confirm },
                  validator: [VueFormGenerator.validators.string,
                      (value, field, model) => {
                        if (model.login_password != value) {
                          return [this.$t('field.warning.mismatch_password')]
                        } else {
                          return [];
                        }
                      }
                    ]
                },
                {
                  type: 'input',
                  inputType: 'email',
                  model: 'display_email',
                  required: true,
                  min: 6,
                  max: 45,
                  visible: () => { return this.license_validate && this.account_validate },
                  disabled: () => { return this.form_confirm },
                  validator: [VueFormGenerator.validators.email, VueFormGenerator.validators.string],
                },
                {
                  type: 'tel-input',
                  model: 'display_phone',
                  defaultCountry: 'JP',
                  onlyCountries: ['JP'],
                  visible: () => { return this.license_validate && this.account_validate },
                  disabled: () => { return this.form_confirm },
                  validate: () => {
                  },
                  input: (formattedNumber, { number, valid }) => {
                    if (valid) {
                      this.phone_validate = true
                      this.model.display_international_phone = number.international
                    }
                    else {
                      this.phone_validate = false
                      this.model.display_international_phone = number.input
                    }
                  }
                },
              ]
            },
          ]
        },
        formOptions: {
          validateAfterLoad: false,
          validateAfterChanged: true,
        },
        license_validate: false,
        account_validate: false,
        phone_validate: false,
        form_confirm: false,
        form_submit: false,
        start_form_validate: false,
        validating: false,
        loading: false
      }
    },
    created() {
      // set recaptcah site key
      this.recaptcha_site_key = process.env.VUE_APP_RECAPTCHA_SITE_KEY

      // update default langs
      Object.assign(VueFormGenerator.validators.resources, this.$t('vue_form_generator_resources'))

      // update fields
      this.schema.groups.forEach((group) => {
        // check group label
        group.fields.forEach((field) => {
          // check field langs
          field.label = this.$t('form.' + field.model + '.label')
          field.placeholder = this.$t('form.' + field.model + '.placeholder')
          field.hint = this.$t('form.' + field.model + '.hint')

          // check field buttons langs
          if (field.hasOwnProperty('buttons') && Array.isArray(field['buttons'])) {
            field['buttons'].forEach((button, index) => {
              button.label = this.$t('form.' + field.model + '.button_labels[' + index + ']')
            })
          }
        })
      })

      // update validate fields
      this.validateSchema.groups[0].fields.forEach((field) => {
        // check field langs
        field.label = this.$t('validate_form.' + field.model + '.label')
        field.placeholder = this.$t('validate_form.' + field.model + '.placeholder')
        field.hint = this.$t('validate_form.' + field.model + '.hint')

        // check field buttons langs
        if (field.hasOwnProperty('buttons') && Array.isArray(field['buttons'])) {
          field['buttons'].forEach((button, index) => {
            button.label = this.$t('validate_form.' + field.model + '.button_labels[' + index + ']')
          })
        }
      })
      this.validateSchema.groups[0].legend = this.$t('validate_form.' + this.validateSchema.groups[0].model + '.label')

      // update query list first
      for (var key in this.$route.query) {
        // check actiovation is preload or not
        if (key === 'activation_code') {
          this.validating = true
          this.model.license_id = this.$route.query[key]
        }
      }
    },
    methods: {
      // toast
      makeToast(variant, title, body) {
        this.$bvToast.toast(body, {
          title: title,
          variant: variant,
          solid: true
        })
      },
      openValidateModal(recaptcha_response) {
        // update button
        if (this.otp_interval.id === null) {
          this.otp_button.label = this.$t('button.title.otp_request')
          this.handleOTPRequestClicked(recaptcha_response)
        }
        else {
          this.otp_button.label = this.$t('button.title.otp_resend').replace('%s', this.otp_interval.count)
        }

        // show modal
        this.$bvModal.show('validate-modal')
      },
      closeValidateModal() {
        // hide modal
        this.$bvModal.hide('validate-modal')
      },
      startOTPRequestInterval() {
        // prepare params
        this.otp_interval.count = this.otp_interval.limit

        // start the interval
        this.otp_button.label = this.$t('button.title.otp_resend').replace('%s', this.otp_interval.count)
        this.otp_button.disabled = true
        this.otp_interval.id = setInterval(() => {
          if (this.otp_interval.count -- <= 0) {
            this.otp_button.label = this.$t('button.title.otp_request')
            this.otp_button.disabled = false
            clearInterval(this.otp_interval.id)
            this.otp_interval.id = null
          }
          else {
            this.otp_button.label = this.$t('button.title.otp_resend').replace('%s', this.otp_interval.count)
            this.otp_button.disabled = true
          }
        }, this.otp_interval.timeout)
      },
      stopOTPRequestInterval() {
      },
      // row button clicked
      handleLicenseValidationClicked(recaptcha_response) {
        // check license offline
        if (this.validating === false || this.model.license_id === null || this.model.license_id.length === 0) {
          // show toast
          this.makeToast('warning', this.$t('toast.title.warning'), this.$t('toast.msg.invalid_code'))
          return
        }

        // check licnese online
        this.loading = true
        const config = { 'headers': { 'recaptcha-response': recaptcha_response } }
        this.$http.get('/api/licenses/' + this.model.license_id + '/validation', config).then(response => {
          console.log(response)

          // update status
          this.loading = false
          this.validating = false

          // update fields
          this.license_validate = true
          this.model.license_product = response.data.product_name
          this.model.license_plan = response.data.plan_name
          this.model.license_term = response.data.expiration
          this.login_host = response.data.login_host

          // update groups
          this.schema.groups[0].legend = this.$t('form.' + this.schema.groups[0].model + '.label')
          this.schema.groups[1].legend = this.$t('form.' + this.schema.groups[1].model + '.label')
        }).catch(error => {
          console.log(error)

          // update status
          this.loading = false

          // show toast
          if (error.response.status == 400) {
            this.makeToast('warning', this.$t('toast.title.warning'), this.$t('toast.msg.invalid_code'))
          }
          else {
            this.makeToast('warning', this.$t('toast.title.warning'), this.$t('toast.msg.failure'))
          }
        })
      },
      handleAcccountValidationClicked(recaptcha_response) {
        // check account offline
        if (this.validating === false || this.model.login_account === null || this.model.login_account.length === 0) {
          // show toast
          this.makeToast('warning', this.$t('toast.title.warning'), this.$t('toast.msg.inavailable_account'))
          return
        }

        // check account online
        this.loading = true
        const config = { 'headers': { 'recaptcha-response': recaptcha_response } }
        this.$http.get('/api/licenses/' + this.model.license_id + '/accounts/' + this.model.login_account + '/validation', config).then(response => {
          console.log(response)

          // update status
          this.loading = false
          this.validating = false

          // update fields
          this.account_validate = true
        }).catch(error => {
          console.log(error)

          // update status
          this.loading = false

          // show toast
          if (error.response.status == 400) {
            this.makeToast('warning', this.$t('toast.title.warning'), this.$t('toast.msg.inavailable_account'))
          }
          else {
            this.makeToast('warning', this.$t('toast.title.warning'), this.$t('toast.msg.failure'))
          }
        })
			},
      handleOTPRequestClicked(recaptcha_response) {
        // check button status
        if (this.otp_button.disabled === true)
          return

        // start otp interval
        this.startOTPRequestInterval()

        // request otp code
        this.loading = true
        const config = { 'headers': { 'recaptcha-response': recaptcha_response } }
        this.$http.post('/api/licenses/' + this.model.license_id + '/otps', JSON.stringify({email: this.model.display_email}), config).then(response => {
          console.log(response)

          // update status
          this.loading = false

          // set otp token
          this.validateModel.otp_token = response.data
        }).catch(error => {
          console.log(error)

          // update status
          this.loading = false

          // show toast
          this.makeToast('warning', this.$t('toast.title.warning'), this.$t('toast.msg.failure'))
        })

      },
      onValidated(isValid) {
        this.validating = isValid
        if (isValid === true && this.start_form_validate === true) {
          // update groups
          this.schema.groups[0].legend = this.$t('form.' + this.schema.groups[0].model + '.confirm_label')
          this.schema.groups[1].legend = this.$t('form.' + this.schema.groups[1].model + '.confirm_label')

          // make toast and change status
          this.makeToast('primary', this.$t('toast.title.confirm'), this.$t('toast.msg.confirm'))
          this.form_confirm = true
        }

        // release event
        this.start_form_validate = false
      },
      handleConfirmClicked() {
        // check phone valid first
        if (this.phone_validate === false && !(this.model.display_international_phone === null || this.model.display_international_phone === '')) {
          this.makeToast('warning', this.$t('toast.title.warning'), this.$t('toast.msg.invalid_phone'))
          return
        }

        this.start_form_validate = true
        this.$refs.form.validate()
      },
      handleConfirmCancelClicked() {
        // update groups
        this.schema.groups[0].legend = this.$t('form.' + this.schema.groups[0].model + '.label')
        this.schema.groups[1].legend = this.$t('form.' + this.schema.groups[1].model + '.label')

        // make toast and change status
        this.makeToast('danger', this.$t('toast.title.modify'), this.$t('toast.msg.confirm'))
        this.form_confirm = false
      },
      handleDoubleConfirmClicked(recaptcha_response) {
        this.openValidateModal(recaptcha_response)
      },
      handleSubmitClicked(recaptcha_response) {
        // check can submit or not
        if (this.form_confirm === false)
          return

        // check otp token and otp code
        if (this.validateModel.otp_token === null || this.validateModel.otp_code === null) {
          this.makeToast('warning', this.$t('toast.title.warning'), this.$t('toast.msg.invalid_otp'))
          return
        }

        // tenant data
        const tenant = {
          license_id: this.model.license_id,
          account: this.model.login_account,
          password: this.model.login_password,
          company: this.model.display_company,
          email: this.model.display_email,
          phone: this.model.display_international_phone,
          tz_offset: new Date().getTimezoneOffset(),
          otp_token: this.validateModel.otp_token,
          otp_code: this.validateModel.otp_code,
        }

        // fill default phone if empty
        if (tenant.phone === null || tenant.phone === '') {
            tenant.phone = '+81 0000000000'
        }

        // do api request
        this.loading = true
        const config = { 'headers': { 'recaptcha-response': recaptcha_response } }
        this.$http.post('/api/licenses/' + this.model.license_id + '/activation', JSON.stringify(tenant), config).then(response => {
          console.log(response)

          // hide modal
          this.closeValidateModal()

          // update status
          this.loading = false
          this.form_submit = true

          // show toast
          this.makeToast('success', this.$t('toast.title.apply'), this.$t('toast.msg.success'))
        }).catch(error => {
          console.log(error)

          // update status
          this.loading = false

          // show toast
          if (error.response.status == 401 || error.response.status == 422) {
            this.makeToast('warning', this.$t('toast.title.warning'), this.$t('toast.msg.invalid_otp'))
          }
          else {
            this.makeToast('warning', this.$t('toast.title.warning'), this.$t('toast.msg.failure'))
          }
        })
      },
      handleSubmitCancelClicked() {
        // reset otp token and otp code
        this.validateModel.otp_token = null
        this.validateModel.otp_code = null

        // hide modal
        this.closeValidateModal()
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
